export const INDIE_API_URL = 'indie-studio';
export const STUDIO_API_URL = 'studio';
export const API_VERSION = 'v1';
export const API_SUCCESS_STATUS_CODE = 0;
